import { Icon } from "@chakra-ui/react";
const WarningIcon = () => {
  return (
    <>
      <Icon
        width="5"
        height="5"
        viewBox="0 0 652 652"
        fill="none"
        marginRight={"5px"}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M326 517.999C344.41 517.999 359.334 503.075 359.334 484.665C359.334 466.256 344.41 451.332 326 451.332C307.591 451.332 292.667 466.256 292.667 484.665C292.667 503.075 307.591 517.999 326 517.999Z"
          fill="white"
        />
        <path
          d="M326 251.332V384.665"
          stroke="white"
          strokeWidth="66.6667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M40.9076 521.52L266.37 70.5907C290.94 21.454 361.06 21.4543 385.63 70.5907L611.093 521.52C633.257 565.847 601.024 618 551.464 618H100.536C50.9769 618 18.7439 565.847 40.9076 521.52Z"
          stroke="white"
          strokeWidth="66.6667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </Icon>
    </>
  );
};

export default WarningIcon;
